import { message } from "antd";
import { EmailTemplateLayoutFormCard } from "./components/EmailTemplateLayoutForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import { EmailTemplateLayout } from "@rumble-it/common-lib/types/models/EmailTemplateLayout.interface";
import {
  fetchEmailTemplateLayoutById,
  updateEmailTemplateLayoutById,
} from "../../../lib/api/resources/emailTemplateLayouts";
import { useNavigate, useParams } from "react-router-dom";

export const EmailTemplateLayoutEdit = () => {
  const { id } = useParams();

  if (!id) return null;
  const navigate = useNavigate();

  const emailTemplateLayoutQuery = useQuery({
    queryKey: ["emailTemplateLayout", id],
    queryFn: () => fetchEmailTemplateLayoutById(id),
  });

  const updateEmailTemplateLayoutMutation = useMutation({
    mutationFn: (data: EmailTemplateLayout) =>
      updateEmailTemplateLayoutById(id, data),
    onSuccess: () => {
      navigate(`/email-templates/layouts/${id}`);
      message.success("Email Template Layout succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de Email Template Layout",
      ),
  });

  return (
    <div>
      <EmailTemplateLayoutFormCard
        loading={emailTemplateLayoutQuery.isLoading}
        initialValues={emailTemplateLayoutQuery.data}
        mutation={updateEmailTemplateLayoutMutation}
        title="Email Template Layout Bijwerken"
        buttonText="Bijwerken"
      />
    </div>
  );
};
